import script from "./UserSettingMenu_global.vue?vue&type=script&setup=true&lang=js"
export * from "./UserSettingMenu_global.vue?vue&type=script&setup=true&lang=js"

import "./UserSettingMenu_global.vue?vue&type=style&index=0&id=a1e91ca6&lang=scss"

const __exports__ = script;

export default __exports__